import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';
import { useAliveController } from 'react-activation';
import styles from './PostLine.module.less';

import { CONTEXT, MICROCONTEXT } from '../../../config';
import { logging, logPostInfo } from '../../../actions/log';
import Toast from '../../Toast/Toast';
import SoftTagLine from '../SoftTagLine/SoftTagLine';
import { formatNumber } from '../../../utils/utils';
import defaultImg from '../../../static/default.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { forumData = {}, logInfo } = props;
  const logInfoData = useSelector(selectLogInfo);
  const { drop, dropScope, getCachingNodes } = useAliveController();

  const handleForum = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Post_LineCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: forumData.id,
          searchWord: logInfo.searchWord,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
        },
        param3: forumData?.bizInfo || '{}',
      }),
    );
    dispatch(
      logPostInfo({
        source_p: `${logInfo.source}`,
        source_pp: logInfoData.source_p,
      }),
    );

    getCachingNodes().forEach((item, index) => {
      if (item.id.indexOf(forumData.id) > -1) {
        dropScope(/forumdetail/);
      }
    });
    setTimeout(() => {
      if (forumData?.type === 2) {
        history.push(`${CONTEXT}/special?ztId=${forumData.id}&bizInfo=${forumData.bizInfo}`);
      } else {
        history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${forumData.id}`);
      }
    }, 50);
  });

  const calculateSearchShowCont = searchText => {
    if (!searchText) return '';
    let indexEm = searchText.indexOf('<em>');
    let len = searchText.length;
    let pointArr = ['。', '  ', '.', '？', '?', '！', '!', '；', ';', '：', ':', '，', ','];
    let showSearchText = searchText;
    if (indexEm > 50) {
      let temp = searchText.slice(indexEm - 50, indexEm);

      for (let i = 0; i < pointArr.length; i++) {
        let indexPoint = temp.indexOf(pointArr[i]);
        if (indexPoint > -1) {
          showSearchText = searchText.slice(indexEm - 50 + indexPoint + 1, len);
          break;
        }
      }
    }
    return showSearchText;
  };

  return (
    <div className={styles.sf_forum_item}>
      <div className={styles.sf_forum_item_title_box}>
        <div
          className={styles.sf_forum_item_title}
          onClick={() => {
            handleForum();
          }}
        >
          {forumData?.type && (
            <div
              className={`${
                forumData?.type === 1 ? styles.sf_forum_tiezi : styles.sf_forum_zhuanti
              }`}
            ></div>
          )}
          {forumData.tags && forumData.tags.notice === 1 && (
            <div className={`${styles.sf_forum_gonggao}`}></div>
          )}
          {forumData &&
            forumData.typeListIcon &&
            forumData.type &&
            (!forumData.tags || forumData.tags.notice !== 1) && (
              <img className={`${styles.sf_forum_line_icon}`} src={forumData.typeListIcon} />
            )}
          <div
            className={styles.sf_forum_title}
            dangerouslySetInnerHTML={{
              __html: forumData.title,
            }}
          ></div>
          {forumData.tags && forumData.tags.handpick === 1 && (
            <div className={styles.sf_forum_jing}></div>
          )}
          {forumData.top === 1 && <div className={styles.sf_forum_ding}></div>}
        </div>
        {forumData.datas && (
          <div className={styles.sf_forum_rscs}>
            <div className={styles.sf_forum_rsc_item} onClick={() => {}}>
              <span className={`${styles.sf_forum_icon} iconfont icon-fread`}></span>
              <span className={styles.sf_forum_rsc_text}>
                {formatNumber(forumData.datas.watchCount || 0)}
              </span>
            </div>
            <div className={styles.sf_forum_rsc_item} onClick={() => {}}>
              <span className={`${styles.sf_forum_icon} iconfont icon-fcomment`}></span>
              <span className={styles.sf_forum_rsc_text}>
                {formatNumber(forumData.datas.commentCount || 0)}
              </span>
            </div>
          </div>
        )}
      </div>
      <div
        className={styles.sf_forum_item_body}
        onClick={() => {
          handleForum();
        }}
      >
        {forumData.textDesc || forumData.text ? (
          <div
            className={styles.sf_forum_item_cont}
            dangerouslySetInnerHTML={{
              __html: forumData.textDesc || calculateSearchShowCont(forumData.text),
            }}
          ></div>
        ) : (
          <div className={styles.sf_forum_item_cont}>如题，进入详情查看完整内容</div>
        )}
      </div>

      <div className={styles.sf_forum_item_header}>
        <div
          className={styles.sf_forum_item_user}
          onClick={() => {
            handleForum();
          }}
        >
          <div className={styles.sf_forum_item_user_img}>
            {forumData?.type === 2 && forumData.userAvatar ? (
              <img className={styles.user_img} src={forumData.userAvatar} alt={''} />
            ) : forumData.userAvatar ? (
              <img className={styles.user_img} src={forumData.userAvatar} alt={''} />
            ) : (
              <div className={styles.user_img_error}></div>
            )}

            {forumData.isV !== 0 && <div className={styles.user_img_v} />}
          </div>
          <div className={styles.sf_forum_item_user_name}>
            {forumData?.type === 2 ? '商店小编' : forumData.userName || '圈友'}
          </div>
          <div className={styles.sf_forum_item_user_pubtime}>{forumData.pushTimeDesc}</div>
          <div className={styles.sf_forum_item_user_news}>{forumData.interactionTimeDesc}</div>
        </div>
        <SoftTagLine forumData={forumData} logInfo={logInfo} />
      </div>
    </div>
  );
};
